/**
 * Date input format configuration in `Intl.DateTimeFormatOptions` format.
 *
 * The configuration is equal to `MM/dd/yyyy HH:mm` in **Date-Time Format String** pattern
 *
 * Example: `02/05/2025, 11:44`
 */
export const CUSTOM_DATE_INPUT: Intl.DateTimeFormatOptions = {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
  timeZone: 'UTC',
};

